module.exports = __webpack_public_path__ + "static/media/notify.58327fbe.svg";